import AgentsPhoneNumber from '@root/agents/src/utils/agents-phone-number';
import Button from '@root/gatsby-contentful-core/src/components/button';
import Modal from '@root/gatsby-contentful-core/src/components/modal';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import useAgentSchedule from '@root/agents/src/hooks/use-agent-schedule';
import useAnalytics from '@root/core/src/hooks/use-analytics';
import { Colors } from '@root/core/src/utils/styles';
import { StyleSheet } from '@root/core/src/utils/styles';
import { bold, regular } from '@root/brand/src/assets/fonts/root-sans/emotion';
import { isMobileBrowser } from '@root/core/src/utils/detect-mobile-browser';

const suffix = (hour) => hour >= 12 ? 'p.m.' : 'a.m.';
const twelveHourFormat = (hour) => (hour + 11) % 12 + 1;

const format = (hour) => `${twelveHourFormat(hour)} ${suffix(hour)}`;

export default function AgentsPhoneNumberModal({
  ctaText = 'Call customer support',
  onDismiss,
  isShowing,
  phoneNumberString,
  speakWithString = 'customer support',
}) {
  const { trackEvent } = useAnalytics('AGENTS', false);
  const { operatingHoursStart, operatingHoursEnd } = useAgentSchedule();

  const handleClickPhoneNumber = () => {
    trackEvent('DID_CLICK_PHONE_NUMBER',
      {
        'phoneNumber': phoneNumberString,
        speakWithString,
      }
    );

    location.assign(AgentsPhoneNumber.phoneFullURL(phoneNumberString));
  };

  return (
    <Modal
      renderCloseButton
      isShowing={isShowing}
      name={'joinroot-agents-phone-number-modal'}
      onClose={onDismiss}
    >
      {isMobileBrowser() ? (
        <h1 css={styles.agentsHeader}>
          Call
          <a
            css={styles.phoneNumber}
            href={'#'}
            onClick={handleClickPhoneNumber}
          >
            {AgentsPhoneNumber.formatAgentPhoneNumber(phoneNumberString)}
          </a> to speak with {speakWithString}
        </h1>
      ) : (
        <h1 css={styles.agentsHeader}>
          Call {AgentsPhoneNumber.formatAgentPhoneNumber(phoneNumberString)} to speak with {speakWithString}
        </h1>
      )}

      <p css={styles.subtext}>We’re available between {format(operatingHoursStart)} to {format(operatingHoursEnd)} ET.</p>

      {isMobileBrowser() && (
        <Button
          css={styles.cta}
          onClick={handleClickPhoneNumber}
        >
          {ctaText}
        </Button>
      )}

      <a
        css={styles.close}
        onClick={onDismiss}
      >
        Close
      </a>
    </Modal>
  );
}

const styles = StyleSheet.create({
  agentsHeader: {
    marginBottom: 20,
    fontSize: 32,
    ...bold(),
    ...Responsive.lessThanSm({
      fontSize: 28,
    }),
  },
  phoneNumber: {
    color: Colors.rootOrange(),
    marginLeft: 5,
    textDecoration: 'underline',
  },
  subtext: {
    fontSize: 18,
    marginBottom: 20,
    ...regular(),
  },
  cta: {
    width: '100%',
    marginBottom: 20,
  },
  close: {
    color: Colors.rootOrange(),
    cursor: 'pointer',
    textDecoration: 'underline',
    textAlign: 'center',
    display: 'block',
    width: '100%',
    ...Responsive.lessThanSm({
      marginBottom: 20,
    }),
  },
});

AgentsPhoneNumberModal.propTypes = {
  ctaText: PropTypes.string,
  isShowing: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
  phoneNumberString: PropTypes.string.isRequired,
  speakWithString: PropTypes.string,
};
